/**
 * Formats a date string for display in the saved queries UI.
 *
 * @param {string|null} dateStr
 * @returns {string}
 */
export function formatQueryDate (dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  })
}
